import { accountingRules } from './accountingRules';
import { aiRules } from './aiRules';
import { coreRules } from './coreRules';
import { leasingRules } from './leasingRules';
import { listingRules } from './listingRules';
import { maintenanceRules } from './maintenanceRules';
import { otherRules } from './otherRules';
import { propertyRules } from './propertyRules';
import { reportRules } from './reportRules';
import { userRules } from './userRules';
import type { RouteRule } from '~/components/layouts/Navigation/BreadcrumbContainer/functional/types';

export const routeRules: RouteRule[] = [
  ...aiRules,
  ...coreRules,
  ...propertyRules,
  ...listingRules,
  ...leasingRules,
  ...userRules,
  ...reportRules,
  ...accountingRules,
  ...maintenanceRules,
  ...otherRules,
].sort((a, b) => (b.priority || 0) - (a.priority || 0));

export {
  aiRules,
  coreRules,
  propertyRules,
  listingRules,
  leasingRules,
  userRules,
  reportRules,
  accountingRules,
  maintenanceRules,
  otherRules,
};
